module.exports = __webpack_public_path__ + "static/media/sc1.7fe85a81.jpg";